import React, { useState, useEffect } from 'react';
import { Collapse } from 'react-collapse';
import './Faq.css'; // Você pode criar um CSS básico para o FAQ se quiser

const FAQ = () => {
  const [faqData, setFaqData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const fetchFAQ = async () => {
      try {
        const response = await fetch('https://gsx2json.com/api?id=1_CySmE5K6kHcqcyrw8VszhmjFxWOjIrHgICfSe1E0Ac&sheet=FAQ');
        // Qualquer pessoa do time pode alimentar e aparecerá de imediato na página 
        // https://docs.google.com/spreadsheets/d/1_CySmE5K6kHcqcyrw8VszhmjFxWOjIrHgICfSe1E0Ac/edit?gid=0#gid=0 
          const data = await response.json();
        if (data.rows) {
          setFaqData(data.rows);
        }
      } catch (error) {
        console.error('Erro ao carregar FAQ:', error);
      }
    };

    fetchFAQ();
  }, []);

  return (
    <section className="faq container" role="list">
      {faqData.map((faq, i) => (
        <div
          key={i}
          className={`faq-item ${openIndex === i ? 'open' : ''}`}
          role="listitem"
          aria-expanded={openIndex === i}
        >
          <button
            className="faq-question"
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
            aria-controls={`faq-answer-${i}`}
            aria-expanded={openIndex === i}
          >
            {faq.question}
            <span className="faq-icon" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
          </button>

          <Collapse isOpened={openIndex === i}>
            <div id={`faq-answer-${i}`} className="faq-answer">
              <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </div>
          </Collapse>
        </div>
      ))}
    </section>
  );
};

export default FAQ;
